module.exports = {
  "country": "RU",
  "artist": "Buranovskie Babushki",
  "song": "Party for Everybody",
  "year": "2012",
  "place": "2",
  "spotify": "6lnmAjsr6xgYJA2RCtncEA"
};